import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { View, ViewProps } from 'react-native';

export type MeasurableProps = ViewProps & {
  onMeasure: (x: number, y: number, width: number, height: number) => void;
  commitMeasure: (x: number, y: number) => void;
  children?: React.ReactNode;
}

export interface MeasurableHandle {
  measureLayout: () => void;
  commitMeasure: () => void;
}

const Measurable = forwardRef<MeasurableHandle, MeasurableProps>((props, ref) => {
  const viewRef = useRef<View>(null);
  
  useImperativeHandle(ref, () => ({
    measureLayout: () => {
      if (viewRef.current) {
        viewRef.current.measure((_x, _y, width, height, pageX, pageY) => {
          const mX = Math.round(pageX).toFixed(0);
          const mY = Math.round(pageY).toFixed(0);
          props.onMeasure && props.onMeasure(+mX, +mY, width, height);
        });
      }
    },
    commitMeasure: () => {
      if (viewRef.current) {
        viewRef.current.measureInWindow((_x, _y) => {
          const mX = Math.round(_x).toFixed(0);
          const mY = Math.round(_y).toFixed(0);
          props.commitMeasure && props.commitMeasure?.(+mX, +mY);
        });
      }
    }
  }));

  return (
    <View
      {...props}
      ref={viewRef}
    // onLayout={({nativeEvent}) => {
    //   const mX = Math.round(nativeEvent.layout.x).toFixed(0);
    //   const mY = Math.round(nativeEvent.layout.y).toFixed(0);
    //   props.onMeasure && props.onMeasure(+mX, +mY, nativeEvent.layout.width, nativeEvent.layout.height);
    // }}
    >
      {props.children}
    </View>
  );
});

export default Measurable;
